module.exports = __webpack_public_path__ + "media/images/projects/fat__right-430ca8362fc9bc85c87c35be71641be6.png";